import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=8f81248a&"
import script from "./XSelect.vue?vue&type=script&lang=js&"
export * from "./XSelect.vue?vue&type=script&lang=js&"
import style0 from "./XSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports